import "@capacitor/core";
import platformMixin from "./capacitor/platforms.mixin";

export * from "./capacitor";
export * from "./cordova";
/**
 * Configure the app with a pre-configured Capacitor
 * [Capacitor]{ @link https://capacitor.ionicframework.com/docs/ }
 */
export default function configureMobile(VueInstance) {
  VueInstance.mixin(platformMixin);
}
